import { render, staticRenderFns } from "./datatable-import.vue?vue&type=template&id=30ecfc6f&scoped=true"
import script from "./datatable-import.vue?vue&type=script&lang=js"
export * from "./datatable-import.vue?vue&type=script&lang=js"
import style0 from "./datatable-import.vue?vue&type=style&index=0&id=30ecfc6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ecfc6f",
  null
  
)

export default component.exports